import * as themes from '@mdx-deck/themes';
export * from 'gatsby-theme-mdx-deck';
export { themes };